import React from 'react';
import { Link } from 'react-router-dom';
import { useFeatureAccess } from '@/admin/FeatureGate';
import styles from './Button.module.css';

export function Button({
  children,
  variant = 'primary',
  size = 'default',
  to,
  type = 'button',
  disabled = false,
  loading = false,
  icon,
  className = '',
  onClick,
  featureId,
  title,
  ...props
}) {
  const featureAccess = featureId ? useFeatureAccess(featureId) : null;
  const isActionDisabled = disabled || loading || Boolean(featureAccess?.disabled);
  const resolvedTitle = title || featureAccess?.reason || undefined;
  const classes = [
    styles.btn,
    styles[variant],
    styles[size],
    loading ? styles.loading : '',
    className
  ].filter(Boolean).join(' ');

  const content = (
    <>
      {loading ? (
        <span className={styles.spinner} aria-hidden="true" />
      ) : icon ? (
        <span className={styles.iconWrapper}>{icon}</span>
      ) : null}
      <span className={styles.label}>{children}</span>
    </>
  );

  if (to && !isActionDisabled) {
    return (
      <Link to={to} className={classes} title={resolvedTitle} {...props}>
        {content}
      </Link>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      disabled={isActionDisabled}
      onClick={onClick}
      title={resolvedTitle}
      {...props}
    >
      {content}
    </button>
  );
}
